module.exports = __webpack_public_path__ + "static/media/snap.5ca80549.png";